const PADDING_START_TWO = 2

const formatWithLeadingZero = (number: number): string =>
  String(number).padStart(PADDING_START_TWO, '0')

export const timeGetIsoDateString = (
  day: number,
  month: number,
  year: number,
): string => {
  return `${year}-${formatWithLeadingZero(month)}-${formatWithLeadingZero(day)}`
}
